import { render, staticRenderFns } from "./FilterDate.vue?vue&type=template&id=38cdcb0a&scoped=true&"
import script from "./FilterDate.vue?vue&type=script&lang=ts&"
export * from "./FilterDate.vue?vue&type=script&lang=ts&"
import style0 from "./FilterDate.vue?vue&type=style&index=0&id=38cdcb0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cdcb0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cdcb0a')) {
      api.createRecord('38cdcb0a', component.options)
    } else {
      api.reload('38cdcb0a', component.options)
    }
    module.hot.accept("./FilterDate.vue?vue&type=template&id=38cdcb0a&scoped=true&", function () {
      api.rerender('38cdcb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/FilterDate.vue"
export default component.exports